<template lang="html">
  <v-dialog
    v-model="internalValue"
    :hide-overlay="!overlay"
    persistent
    width="350"
  >
    <v-card height="210">
      <v-layout
        align-center
        justify-center
        fill-height
        ma-0
      >
        <v-flex
          shrink
          text-center
          pa-0
        >
          <v-progress-circular
            indeterminate
            :color="color"
            size="36"
          />
          <div :class="`mt-10 body-2 font-weight-medium ${color}--text`">
            {{ label }}
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    value: Boolean,
    label: {
      type: String,
      default: 'loading...'
    },
    overlay: Boolean,
    color: {
      default: 'primary'
    }
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (v) {
        this.lazyValue = v
        this.$emit('input', v)
      }
    }
  },
  watch: {
    value (v) {
      this.internalValue = v
    }
  }
}
</script>

<style lang="css" scoped>

</style>
